
import React from 'react'
import { Select, SelectProps } from 'antd';

export const IssueModeType = {
  receive: 'receive', // 主动领取
  grant: 'grant', // 定向发放
  register: 'register', // 邀请注册
  new_user: 'new_user', // 注册即享
} 

export const IssueModeTypeMap = {
  [IssueModeType.receive]: '主动领取',
  // Ai Start
  [IssueModeType.grant]: '定向发放',
  [IssueModeType.register]: '邀请注册',
  [IssueModeType.new_user]: '注册即享',
  // Ai End
}

export interface FilterIssueModeProps extends SelectProps {}


export const FilterIssueMode = (props: FilterIssueModeProps) => {
  const { placeholder = '发放方式', mode, ...reset } = props;
  const options = Object.entries(IssueModeTypeMap).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={[{ label: "全部", value: '' }, ...options]}
      placeholder={placeholder}
      {...reset}
    />
  )
}